import { apiClient } from '../client/apiClient';
import { fetchCsrfToken } from '../client/fetchCsrfToken';

export type InquiryRequestBody = {
  alias: string;
  email: string;
  name: string;
  phone?: string;
  text: string;
  beds?: string | number | null;
  baths?: string | number | null;
  checkInDate?: string;
  emailUser?: boolean;
  modelId?: string | null;
  requestToApply?: boolean;
  rentalSubmitId?: string;
  ref?: string;
};

export type InquiryResponse = {
  success?: boolean;
  loggedIn?: boolean;
  validationStatus?: string;
  status?: string;
  message?: string;
  error?: string | boolean | Record<string, unknown>;
  cachedRequest?: boolean;
  creds?: {
    csrfToken?: string;
  };
};

export type ContactValidationResponse = {
  data?: {
    email?: { valid?: boolean };
    phone?: { valid?: boolean };
  };
};

export type InquiryMessageCache = {
  email?: string | null;
  name?: string | null;
  phone?: string | null;
  text?: string | null;
};

export type InquiryMessageCacheResponse = {
  data?: InquiryMessageCache;
};

export type DisplaySearchPromptPostInquiryFilter = {
  areas?: string;
  minLat?: number;
  maxLat?: number;
  minLon?: number;
  maxLon?: number;
};

export type DisplaySearchPromptPostInquiryResponse = {
  data?: boolean;
};

export const submitInquiry = async (body: InquiryRequestBody): Promise<InquiryResponse> => {
  const csrfToken = await fetchCsrfToken();
  const headers: Record<string, string> = {};
  if (csrfToken) {
    headers.csrfToken = csrfToken;
  }

  const response = await apiClient<InquiryResponse>({
    method: 'PUT',
    path: '/v2/listing/inquiry',
    body: {
      ...body,
      emailUser: body.emailUser ?? true,
    },
    headers,
  });
  return response;
};

export const validatePhoneAndEmail = async (params: {
  listingAlias?: string;
  email?: string;
  phone?: string;
}): Promise<ContactValidationResponse> => {
  return apiClient<ContactValidationResponse>({
    path: '/v2/listing/validatePhoneAndEmail',
    queryParams: params,
  });
};

export const getInquiryMessageCache = async (): Promise<InquiryMessageCacheResponse> => {
  return apiClient<InquiryMessageCacheResponse>({
    path: '/v2/user/inquiryMessageCache',
  });
};

export const displaySearchPromptPostInquiry = async (
  filter: DisplaySearchPromptPostInquiryFilter,
): Promise<DisplaySearchPromptPostInquiryResponse> => {
  return apiClient<DisplaySearchPromptPostInquiryResponse>({
    method: 'POST',
    path: '/v2/user/savedSearch/displaySearchPromptPostInquiry',
    body: { filter },
  });
};

export const inquiry = {
  submitInquiry,
  validatePhoneAndEmail,
  getInquiryMessageCache,
  displaySearchPromptPostInquiry,
};
